import { useEffect, useState } from 'react';
import { brandingApi, BrandingConfig, getFallbackBranding } from '../services/branding';

let brandingCache: BrandingConfig = getFallbackBranding();

export const useBranding = () => {
  const [branding, setBranding] = useState<BrandingConfig>(brandingCache);

  useEffect(() => {
    let cancelled = false;

    brandingApi.getBranding()
      .then((nextBranding) => {
        brandingCache = nextBranding;
        if (!cancelled) {
          setBranding(nextBranding);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return { branding };
};
